var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('the-heading'),_c('div',{staticClass:"app-content"},[_c('left-menu'),_c('keep-alive',{attrs:{"exclude":"WorkCounts"}},[_c('router-view',{staticClass:"app-router-view"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }